var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewReleases(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.48464 14L4.21797 11.8667L1.81797 11.3333L2.0513 8.86667L0.417969 7L2.0513 5.13333L1.81797 2.66667L4.21797 2.13333L5.48464 0L7.7513 0.966667L10.018 0L11.2846 2.13333L13.6846 2.66667L13.4513 5.13333L15.0846 7L13.4513 8.86667L13.6846 11.3333L11.2846 11.8667L10.018 14L7.7513 13.0333L5.48464 14ZM7.0513 9.36667L10.818 5.6L9.88464 4.63333L7.0513 7.46667L5.61797 6.06667L4.68464 7L7.0513 9.36667Z",
    fill: "#3B0069"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewReleases);
export default __webpack_public_path__ + "static/media/new_releases.850cef57814af425d8e2f7fe27d358b2.svg";
export { ForwardRef as ReactComponent };